module.exports = __webpack_public_path__ + "r-v3/img/ico_polygon_gray.f1fa39e4.svg";